module.exports = __webpack_public_path__ + "static/3-1-4da3eadbbc846f8689ecb2dcbf6f9be8.png";